<template>
  <div>
    <div v-bind:class="loader">
      <div class="col-12 text-center mt-5">
        <a href="" class="btn btn-link btn-lg" style="font-size: 30px">
          <i class="fas fa-spinner"></i>
        </a>
      </div>
    </div>
    <div v-bind:class="result">
      <router-view />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import { EventBus } from "@/utils/EventBus";
import { VersionIxeEnum } from "@/utils/enums/VersionIxeEnum";
import GeneralMixin from "@/components/mixins/General";

import * as _ from "lodash";
import moment from "moment-timezone";

export default {
  mixins: [GeneralMixin],
  data() {
    return {
      loader: "",
      result: "d-none",
      token: null,
      tokenRefresh: null,
      updatingToken: false,
      path: "",
      msal: "msal." + process.env.VUE_APP_CLIENT_ID + ".idtoken",
    };
  },
  created() {
    this.token = localStorage.getItem("apiKey_tp");
    this.tokenRefresh = localStorage.getItem("tp_refresh_token");

    this.Escuchar_Eventos();
    this.Asignar_Unauthenticated_Interceptor();
    this.Asignar_Interceptor_Token();
    this.Validar_Token();
  },
  methods: {
    Obtener_Url(usuario, url) {
      return _.get(usuario, "sistema", null) == VersionIxeEnum.R3 ? "r3/" + url : url;
    },
    Mostrar_Result() {
      this.loader = "d-none";
      this.result = "";
    },
    Mostrar_Loader() {
      this.loader = "";
      this.result = "d-none";
    },
    Back_To_Login() {
      console.log('Back_To_Login');
      const login_path = "/";
      if (!this.$msal.isAuthenticated()) {
        this.$msal.signIn();
        this.$router.push({ name: "Login" });
      } else {
        if (this.$route.path !== login_path) {
          return this.$router.push({ name: "Login" }).then(() => {
            this.Mostrar_Result();
          });
        } else {
          return Promise.resolve().then(() => {
            this.Actualizar_TokenMsal(localStorage.getItem(this.msal));
            this.Mostrar_Result();
          });
        }
      }
    },
    Go_To_Menu() {
      // if (this.$route.path != "/menu/dashboard") {
      //   this.path = this.$route.path.split("/");
      //   this.path.shift();
      //   this.path.shift();
      //   this.path = this.path[0];
      //   this.path = this.path.charAt(0).toUpperCase() + this.path.slice(1);
      // }
      this.$router.push({ name: "Dashboard" });
      // console.log(this.path);
      // this.$router.push({ name: this.path });
    },
    Escuchar_Eventos() {
      EventBus.$on("custom-event:logout", (data) => {
        this.Asignar_Interceptor_Token();
        this.Actualizar_Usuario({ usuario: null });
        this.Actualizar_TokenRefresh("");
        this.Actualizar_Token("");
        this.tokenRefresh = "";
        this.token = "";
        this.Consultar_Token_Generico()
          .then((data) => {
            this.token = data.token;
            this.Actualizar_TokenGenerico(this.token);
            this.Actualizar_Token(this.token);
          })
          .catch((e) => {
            this.Actualizar_TokenGenerico(null);
          });
      });
    },
    Asignar_Unauthenticated_Interceptor() {
      Vue.http.interceptors.push((request, next) => {
        return (response) => {
          this.tokenRefresh = localStorage.getItem("tp_refresh_token");
          if (response.status === 401 && !this.updatingToken) {
            this.updatingToken = true;
            // Try to get a new token
            this.Asignar_Interceptor_Token();
            const saved_token_content = this.get_token_contents(this.tokenRefresh);
            if (saved_token_content) {
              const now = moment.utc();
              const rtex = moment.unix(saved_token_content["exp"]).utc();
              if (rtex.isBefore(now)) {
                this.token = null;
                this.tokenRefresh = null;
                this.Actualizar_Token("");
                this.Actualizar_TokenRefresh("");
                this.Validar_Token();
                return;
              }
              this.$http
                .post(
                  this.get_protected_url("token"),
                  {
                    data: {
                      tipo: "WEB",
                    },
                  },
                  {
                    headers: this.get_request_headers({
                      token: this.tokenRefresh,
                    }),
                  }
                )
                .then((resp) => resp.json())
                .then((jsonResp) => {
                  this.token = jsonResp.token;
                  this.Actualizar_Token(this.token);
                  this.Asignar_Interceptor_Token({ token: this.token });
                  this.Validar_Token();
                })
                .catch((error) => {
                  this.token = "";
                  this.tokenRefresh = "";
                  this.Actualizar_Token("");
                  this.Actualizar_TokenRefresh("");
                  this.Validar_Token();
                });
            } else {
              this.token = "";
              this.Actualizar_Token("");
              this.Actualizar_TokenRefresh("");
              this.Validar_Token();
            }
          } else if (response.status === 403 && _.get(response.body, "code", null) === "ACCOUNT_NO_ACCESS") {
            this.updatingToken = true;
            this.token = null;
            this.tokenRefresh = null;
            this.Actualizar_Token("");
            this.Actualizar_TokenRefresh("");
            this.Validar_Token();
          }
        };
      });
    },
    Validar_Token() {
      if (this.token) {
        let stc = this.get_token_contents(this.token);
        if (stc && stc.data.idagente != "Generico") {
          this.Asignar_Interceptor_Token({ token: this.token });
          this.$http
            .get(this.Obtener_Url(stc.data, "encargados/login/" + stc.data.idagente), {
              headers: this.get_request_headers({
                accesstoken: localStorage.getItem("tokenmsal"),
              }),
            })
            .then((respuesta) => respuesta.json())
            .then((respuestaJson) => {
              if (respuestaJson.resp == "Excelente") {
                const encargados = respuestaJson.result;
                const encargado = encargados[0];
                if (encargado.status == "1") {
                  this.Actualizar_Usuario(encargado);
                  this.Mostrar_Result();
                  this.Go_To_Menu();
                }

                this.updatingToken = false;
              }
            })
            .catch((e) => {
              this.Actualizar_Token("");
              this.Actualizar_TokenRefresh("");
              this.Actualizar_TokenGenerico("");
              this.updatingToken = false;
              this.Back_To_Login();
            });
        } else {
          this.Asignar_Token_Generico();
        }
      } else {
        this.Asignar_Token_Generico();
      }
    },
    Consultar_Token_Generico() {
      return this.$http.get(this.get_public_url("token/generico")).then((res) => res.json());
    },
    Asignar_Token_Generico() {
      return this.Consultar_Token_Generico()
        .then((rej) => {
          console.log('rej:' , rej);
          if (rej.token != null) {
            this.token = rej.token;
            this.Actualizar_TokenGenerico(this.token);
            this.Actualizar_TokenRefresh("");
            this.Actualizar_Token(this.token);
          } else {
            this.Actualizar_Token("");
            this.Actualizar_TokenRefresh("");

            swal("Problemas con el servidor", "Favor de intentar mas tarde", "error");
          }

          this.updatingToken = false;
          this.Mostrar_Result();
        })
        .then(() => {
          console.log('theeeeeeen');
          this.Back_To_Login();
        })
        .catch((e) => {
          console.log('catchhhhhhhhhh');
          this.Actualizar_Token("");
          this.Actualizar_TokenRefresh("");
          this.Actualizar_TokenGenerico("");
          this.updatingToken = false;
          this.Mostrar_Result();
          this.Back_To_Login();

          swal("Problemas para conectarse", "Favor de revisar su conexiÃ³n a internet", "error");
        });
    },
    ...mapActions(["Actualizar_TokenGenerico", "Actualizar_TokenRefresh", "Actualizar_Token", "Actualizar_Usuario", "Asignar_Interceptor_Token", "Actualizar_TokenMsal"]),
  },
};
</script>

<style>
body {
  background-color: #80808061 !important;
}
</style>

